<template>
    <div class="payment-calculator">
        <hypothecCalculator></hypothecCalculator>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import hypothecCalculator from '@/components/payment-page/hypothec-calculator.vue';
    export default {
        name: 'payment-calculator',
        components: {
            hypothecCalculator,
            // svgIcon,
        },
        metaInfo() {
            return {
                title: 'Надежный застройщик "DIAL GROUP" - Ипотечный калькулятор',
                meta: [
                    { name: 'description', content:  'Первичные квартиры комфорт-класса в Алмалинском районе от 24 000 000 тенге. В 10 минутах от MEGA Park. Готовые квартиры в ЖК бизнес-класса в золотом квадрате.'},
                ]
            };
        },
        data () {
            return {
            }
        },
        computed: mapGetters({
            paymentPage: 'loadPaymentPage',
        }),
        methods: {
        },
        beforeCreate() {
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/payment-page/payment-calc.scss';
    @import '@/styles/components/payment-page/respond/payment-calc-respond.scss';
</style>